'use strict';

import { bucketing } from './bucketing';
import { nestedGroupBy } from './nestedGroupBy';
import promiseUtil from './promiseUtil';
import routeUtils from './routeUtils';

angular
    .module('sfx.util', [])
    .service('promiseUtil', promiseUtil)
    .service('bucketing', bucketing)
    .service('nestedGroupBy', nestedGroupBy)
    .service('routeUtils', routeUtils);
